<script setup>
import ArgonButton from "@/components/ArgonButton.vue";
import { useRouter } from "vue-router";

const router = useRouter();

defineProps({
  id: {
    type: Number,
    required: true,
  },
  img: {
    type: String,
    default: "",
  },
  category: {
    type: String,
    default: "",
  },
  title: {
    type: String,
    default: "Default Project Card",
  },
  chapters: {
    type: String,
    default: "",
  },
  action: {
    type: Object,
    default: () => ({}),
  },
  authors: {
    type: Array,
    default: () => [],
  },
  price: {
    type: Number,
    default: 0,
  },
  currency: {
    type: Number,
    default: 0, // 0 for $, 1 for ₡
  },
  teacher: {
    type: String,
    default: "Profesor X",
  },
});

const navigateToCourse = (id) => {
  router.push({ path: `/cursos/${id}` });
};

// Helper function to get currency symbol
const getCurrencySymbol = (currencyType) => {
  return currencyType === 0 ? '₡' : '$';
};
</script>

<template>
  <div class="card card-blog h-100 border motion-highlight-card" @click="navigateToCourse(id)">
    <div class="position-relative">
      <a class="shadow-xl d-block border-radius-xl">
        <!-- Dynamic image source with fallback -->
        <img 
          :src="img || require('@/assets/img/home-decor-1.jpg')" 
          alt="course-image" 
          class="shadow img-fluid border-radius-sm course-card-image"
        />
        <!-- Category badge positioned absolutely within the image container -->
        <span class="badge category-badge">{{ category }}</span>
      </a>
    </div>
    <div class="px-4 py-3 pb-1 card-body">
      <a href="javascript:;" class="block">
        <h6 class="multiline-ellipsis">{{ title }}</h6>
      </a>
      <p class="mb-1 text-sm">
        <i class="fas fa-user-tie pe-1"></i>
        {{ teacher }}
      </p>     
  
      <div class="row">
        <div class="mb-0 mb-md-4 col-6 col-md-6 mb-xl-0">
          <p class="my-2 text-md">
            <strong v-if="price > 0">{{ getCurrencySymbol(currency) }}{{ price.toFixed(2) }}</strong>
            <strong v-else>Gratuito</strong>
          </p>
        </div>
        <div class="mb-0 mb-md-4 col-6 col-md-6 mb-xl-0 d-flex justify-content-end">
          <p class="my-2 text-md">
            <i class="fas fa-book-open pe-1"></i>
            <strong>{{ chapters }}</strong>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.motion-highlight-card {
  position: relative;
  transition: box-shadow 0.3s, border-color 0.3s;
  z-index: 1;
  border-radius: 10px;
}
.motion-highlight-card:hover {
  box-shadow: 0 0 0 4px #f1f1f1;
  border-radius: 10px;
  /* animation: highlight-motion 1.2s linear infinite; */
  border: 0.5px solid #f1f1f1;
}

.course-card-image {
  height: 180px;
  width: 100%;
  object-fit: cover !important;
}

.card-blog {
  background-color: rgba(247, 247, 247, 0.699) !important;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 380px; /* Altura mínima para todos los cards */
  max-width: 340px; /* Opcional: para que no sean demasiado anchos */
  margin-left: auto;
  margin-right: auto;
}

.card-body {
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  min-height: 180px; /* Altura mínima del área de información */
  justify-content: flex-start;
}

.img-fluid {
  max-width: 100%;
  object-fit: fill;
}

/* Fixed height for title */
.multiline-ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 3em;
  line-height: 1.5em;
  margin-bottom: 0.5rem;
}

/* Push button to bottom */
.row:last-child {
  margin-top: auto;
}

/* Badge styles - positioned absolutely within the image container */
.category-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 0.65rem;
  font-weight: 700;
  padding: 0.35em 0.65em;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  background: #078EE9;
  color: white;
  z-index: 1;
}

.position-relative {
  position: relative;
}

.card-blog:hover {
  transform: scale(1.015);
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  background-color: rgba(247, 247, 247, 0.918) !important;
}
</style>